import { render, staticRenderFns } from "./Dashboard3.vue?vue&type=template&id=5cca4ac0&"
import script from "./Dashboard3.vue?vue&type=script&lang=js&"
export * from "./Dashboard3.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports